import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    // Znajdź wszystkie kontenery sliderów na stronie
    const sliderContainers = document.querySelectorAll('[data-slider-container]');

    // Jeśli nie ma żadnego kontenera, zakończ
    if (sliderContainers.length === 0) return;

    // Dla każdego kontenera inicjalizuj Swiper z zewnętrznymi przyciskami
    sliderContainers.forEach((container) => {
        // Pobierz unikalny identyfikator kontenera
        const containerId = container.getAttribute('data-slider-container');

        // Znajdź elementy wewnątrz tego kontenera
        const slider = container.querySelector('[data-slider-id="' + containerId + '"]');
        const pagination = container.querySelector('[data-slider-pagination="' + containerId + '"]');
        const prevButton = container.querySelector('[data-slider-prev="' + containerId + '"]');
        const nextButton = container.querySelector('[data-slider-next="' + containerId + '"]');

        // Sprawdź, czy slider istnieje
        if (!slider) {
            console.warn(`Slider element with data-slider-id="${containerId}" not found`);
            return;
        }

        // Inicjalizacja Swipera dla tego kontenera
        const swiperInstance = new Swiper(slider, {
            // Załaduj moduły
            modules: [Pagination, Navigation, Autoplay],

            // Podstawowe ustawienia
            slidesPerView: 2.3,  // Domyślnie pokazuje 1 slajd
            spaceBetween: 15,  // Odstęp między slajdami

            // Autoplay (opcjonalnie)
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            // Opcje paginacji (jeśli element istnieje)
            pagination: pagination ? {
                el: pagination,
                clickable: true,
            } : false,

            // Przyciski nawigacji (jeśli elementy istnieją)
            navigation: (nextButton && prevButton) ? {
                nextEl: nextButton,
                prevEl: prevButton,
            } : false,

            // Ustawienia responsywne zgodnie z wymaganiami
            breakpoints: {
                // >= 768px
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 30,
                },
                // >= 968px
                968: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                // >= 1024px
                1024: {
                    slidesPerView: 2.8,
                    spaceBetween: 30,
                },
                // >= 1200px
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                // >= 1300px
                1300: {
                    slidesPerView: 3.33,
                    spaceBetween: 30,
                },
                1600: {
                    slidesPerView: 4.33,
                    spaceBetween: 30,
                },
                1900: {
                    slidesPerView: 5.33,
                    spaceBetween: 30,
                },
            }
        });

    });
});